import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LocationTrans  {
    _originalTypeClassName = "zERP.BO.LocationTrans";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LocationTrans.translate = translateService;
}
this.Id = null;
this.TransDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TransDate:any;
EmpContract:any;
Location:any;
Floor:any;
DepartmentFloor:any;
static setEmpContract = ($this, value) => {
var oldValue = $this.EmpContract;
$this.EmpContract = value;
if (value != null) {
}
}
static setLocation = ($this, value) => {
var oldValue = $this.Location;
$this.Location = value;
if (value != null) {
}
}
static setFloor = ($this, value) => {
var oldValue = $this.Floor;
$this.Floor = value;
if (value != null) {
}
}
static setDepartmentFloor = ($this, value) => {
var oldValue = $this.DepartmentFloor;
$this.DepartmentFloor = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}